import {buildActionPayloadValidator} from '../schema';

export function applyPayloadValidators(actions) {
	for (const k in actions) {
		const action = actions[k];
		const {schema} = action;
		if (schema) action.validate = buildActionPayloadValidator(schema);
	}

	return actions;
}
